import React, { ReactElement } from "react"
import "twin.macro"
import { injectStyle } from "react-toastify/dist/inject-style"
import Navbar from "../components/navBar"
import Footer from "../components/footer"
import Alert from "../components/alert"

if (typeof window !== "undefined") {
  injectStyle()
}

export const Layout = (page: ReactElement, isblack?: boolean) => {
  // bit of a hack to reduce optional boolean in the child components below
  return (
    <>
      <Alert />
      <Navbar {...{ isblack }} />
      <main data-testid="page">{page}</main>
      <Footer {...{ isblack }} />
    </>
  )
}
